import { isEqual } from "es-toolkit/compat";
import React, { memo } from "react";
import TextDataDisplay from "../../../DataDisplay/TextDataDisplay/TextDataDisplay";
import type { TextCellProps } from "../../types";

const TextCell = ({ style, clamp = 2, ...restProps }: TextCellProps) => {
  return (
    <TextDataDisplay
      {...restProps}
      clamp={clamp}
      style={{ ...(style ?? {}), width: "100%" }}
    />
  );
};

export default memo(TextCell, isEqual);
